export default __webpack_public_path__ + "static/thickness-4aee9aefed5b9e6d69f03d7aee0fbe35.png";